import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import your new page components
import Home from './pages/Home';
import About from './pages/About';
import HowItWorks from './pages/HowItWorks';
import Navbar from './components/Navbar'; // We'll build this next!

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-900 text-white">
        {/* The Navbar stays visible on EVERY page */}
        <Navbar /> 

        <Routes>
          {/* This defines which component shows up for which URL */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
